import '..//styles/Header.css';
import React from 'react';
import '@aws-amplify/ui-react/styles.css';
import { useAuth } from "react-oidc-context";
import { useNavigate } from 'react-router-dom';




function Header() {
    const auth = useAuth();
    const navigate = useNavigate();
    const signOutRedirect = () => {
        auth.removeUser();
        localStorage.clear();
        sessionStorage.clear();
        const clientId = "d5mc6p9n7u66hh61ukipptvls";
        const logoutUri = "https://aec-tool.beg.utexas.edu/landing";
        const cognitoDomain = "https://aec.auth.us-east-1.amazoncognito.com";
        window.location.href = `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(logoutUri)}`;
      };
    console.log(auth.user?.profile)
    return (
        <div className="nav-bar-header">
            
            <div className="nav-bar-options">
                <img className='logo' src='/logo.png' alt = 'Logo' height='50px' align = "left" padding = "0px"/>
                <button className='clear-button' onClick={() => navigate('/', { replace: true })}> Home</button>
                <button className='clear-button' onClick={() =>navigate('/upload/', { replace: true })}> Upload File</button>
                <button className='clear-button' onClick={() => navigate('/presentations/', { replace: true })}> Previous Uploads</button>
            </div> 

            <div className = 'right-side-nav-bar-options'>
                <button className='clear-button' onClick={signOutRedirect}> Sign Out</button>
            </div>

        </div>
    );
}
export default Header;